import RappidContext from "./rappid-context";
import * as joint from "@clientio/rappid";

export default class MouseWheelController {
  constructor(private context: RappidContext) {}

  activate() {
    this.context.paper.on("paper:pinch", (evt, ox, oy, scale) => {
      this.pinchZoom(evt, scale, ox, oy);
    });
  }

  pinchZoom(evt: joint.dia.Event, scale: number, x: number, y: number) {
    const zoom = this.context.paperScroller.zoom();
    this.context.paperScroller.zoom(scale * zoom, {
      min: 0.5,
      max: 4,
      ox: x,
      oy: y,
      absolute: true,
    });
  }
}
